<template>
    <vx-card id="loader">
        <h3 class="mb-4">Рейтинг рекламной кампании {{ id }}, расчет: {{ rating.updatedAt | moment('DD.MM.YYYY HH:mm') }}</h3>

        <vs-table stripe :data="ratingItems" max-items="23" class="mt-5">
            <template slot="header"></template>
            <template slot="thead">
                <vs-th>Название</vs-th>
                <vs-th>Баллы</vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :class="{ 'text-bold': tr.isTotal }">
                    <vs-td class="vs-lg-2">{{ tr.name  }}</vs-td>
                    <vs-td class="vs-lg-2">{{ tr.score }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </vx-card>
</template>

<script>
import axios from 'axios';

export default {
    name: 'campaign-rating',
    props: ['id'],
    data() {
        return {
            rating: {},
            ratingItems: [],
            initialized: false
        };
    },
    components: {},
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                url: 'campaigns/' + this.id + '/rating',
                method: 'GET',
                success: (data) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.rating = data.rating || {};
                    let items = data.items || [];
                    let itemSummary = { 
                        name: 'ИТОГО', 
                        score: data.rating.rating, 
                        isTotal: true 
                    };
                    items.push(itemSummary);
                    this.ratingItems = items;
                    this.initialized = true;
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки логов топа.',
                        color: 'danger'
                    });
                }
            });
        },
        getRatingItems(rating) {
            let items = [];

            let item = { name: 'Таргетинг на все устройства', score: 0 };
            if (rating.pcAndMob) {
                item.score = 1;
            }
            items.push(item);

            item = { name: 'Таргетинг на все браузеры', score: 0 };
            if (rating.allBrowsers) {
                item.score = 1;
            }
            items.push(item);

            item = { name: 'Не используются блек-лист', score: 0 };
            if (rating.withoutBlackList) {
                item.score = 2;
            }
            items.push(item);

            item = { name: 'За последние 7 дней баланс пополнялся с Oneprofit.ru', score: 0 };
            if (rating.incomeFromOneprofit) {
                item.score = 1;
            }
            items.push(item);

            item = { name: 'Не используется временной таргетинг', score: 0 };
            if (rating.withoutTimeTargeting) {
                item.score = 2;
            }
            items.push(item);

            item = { name: 'Есть селективные цены с повышающим коэффициентом', score: 0 };
            if (rating.withSelectivePrices) {
                item.score = 1;
            }
            items.push(item);

            item = { name: 'За прошлые сутки куплено трафика более чем на 30к рублей / 500$', score: 0 };
            if (rating.outcomeYesterdayMoreThanLimit) {
                item.score = 1;
            }
            items.push(item);
            
            item = { name: 'Расход рекламной кампании за прошлые сутки более 5к рублей / 100$', score: 0 };
            if (rating.outcomeYesterdayMoreThanLimitOrCreated) {
                item.score = 1;
            }
            items.push(item);

            item = { name: 'Используется целая cтрана, а не отдельные регионы страны', score: 0 };
            if (rating.allCountryRegions) {
                item.score = 1;
            }
            items.push(item);

            item = { name: 'ИТОГО', score: rating.rating, isTotal: true };
            items.push(item);

            this.ratingItems = items;
        }
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
    tr > td.actions {
        white-space: nowrap;
    }
    tr > td {
        word-break: break-all;
    }
}
thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}
.text-bold {
    font-weight: bold;
}
</style>
